package libres.resources.strings

import io.github.skeptick.libres.strings.formatString
import kotlin.String

public class LibresFormatDownloadsFor(
  private val _value: String,
) {
  public fun format(platform: String): String = formatString(_value, arrayOf(platform))
}
